import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.378 9.456C9.378 7.547 10.948 6 12.885 6s3.507 1.547 3.507 3.456a3.4 3.4 0 0 1-.84 2.244H13.7a2 2 0 0 0-1.777 1.08c-1.47-.411-2.545-1.744-2.545-3.324m2.322 4.85q-1.681.033-3.175.16a2.44 2.44 0 0 0-2.21 2.014l-.296 1.753c-.115.68.297 1.34.966 1.546q1.98.61 4.715.714zm14.412-1.576H13.708a.82.82 0 0 0-.823.812V21.6c0 .447.37.811.823.811h12.404a.82.82 0 0 0 .823-.811v-8.058a.82.82 0 0 0-.823-.812M24.3 24.413h-2.222v-1.19h-4.336v1.19H15.52a.41.41 0 0 0-.411.406c0 .224.184.406.411.406h8.782a.41.41 0 0 0 .411-.406.41.41 0 0 0-.411-.406"
    }
  )
);
var SvgOnboardingFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var OnboardingFilled_default = SvgOnboardingFilled;

export { OnboardingFilled_default as default };
